import styled from 'styled-components';

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  h2 {
    color: #101828;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0px;
  }

  p {
    margin-bottom: 0px;
    color: #667085; 
    font-size: 14px;
    font-weight: 400;
  }

  a {
    color: var(--mmt-primary-70);
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
  }
`;

export default function DashboardPopover({ title, body, action }) {
  return (
    <PopoverContent className='max-w-250'>
      <h2>{title}</h2>
      {Array.isArray(body) ?
        body.map((p, i) => (
          <p key={`par-${i}`}>{p}</p>
        ))
        : <p>{body}</p>}
      {action}
    </PopoverContent>
  );
}
